import { Component } from "@angular/core";
import { ROUTER_DIRECTIVES } from "@angular/router";
import { LoginService } from '../service/login.service';
import { User } from '../domain/user';

@Component( {
    selector: 'config-panel',
    template: require( './config.panel.component.html' ),
    directives: [ROUTER_DIRECTIVES],
} )

export class ConfigPanel {

    private userLogged: User;
    private isAdmin: boolean;
    private isBank: boolean;
    /*private userCredentials:UserCredentials;*/

    constructor(/*private router:Router,*/
        private loginService: LoginService ) {
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        if ( !this.userLogged ) {
            this.loginService.getUserLoggedSubject().subscribe(
                ( userLogged ) => {
                    this.userLogged = userLogged;
                    this.updateUserLogged();
                },
                () => {
                    //Do Nothing.
                } );
        } else {
            this.updateUserLogged();
        }
    }
    private updateUserLogged(): void {
        if ( this.userLogged.isAdmin() ) {
            this.isAdmin = true;
        }
        if ( this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite" ) {
            this.isBank = true;
        }

    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/config.panel.component.ts
 **/